import { createErrorHandler } from "./handling-errors-base";

export const errorMessages: { [key: number]: string } = {
  401: "Error de token",
  404: "Error userId no encontrado",
  410: "Error enrolamiento vacio",
  423: "Error usuario bloqueado",
  409: "There was an unexpected error during interaction with Facephi",
};

export const handlingEnrollmentErrors = createErrorHandler(errorMessages);
